<template>
  <!-- ============================= -->
  <!-- PRODUCTS -->
  <!-- ============================= -->
  <section id="products" class="products-section py-5">
    <div class="container">
      <div class="section-heading text-center mb-5">
        <span class="section-label">Explore Our Marketplace</span>
        <h2 class="textprimary fw-bold mb-2">Featured Products</h2>
        <p class="text-muted mb-0">
          Discover quality products across categories, all in one place.
        </p>
      </div>

      <div
        id="productsCarousel"
        class="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="5000"
      >
        <div class="carousel-inner">
          <div
            v-for="(group, index) in Math.ceil(products.length / 4)"
            :key="index"
            class="carousel-item"
            :class="{ active: index === 0 }"
          >
            <div class="row g-4">
              <div
                v-for="item in products.slice(index * 4, index * 4 + 4)"
                :key="item.id"
                class="col-6 col-md-6 col-lg-3"
              >
                <div class="card product-card h-100 border-0" 
                @click="$router.push({ name: 'ProductsPage', query: { category: item.name } })">
                  <div class="product-image-wrapper">
                    <img
                      :src="item.image"
                      :alt="item.name"
                      class="product-img"
                    />

                    <div class="product-overlay">
                      <span class="product-badge">Quality Product</span>
                    </div>
                  </div>

                  <div class="card-body text-center d-flex flex-column">
                    <h5 class="fw-bold mb-2">
                      {{ item.name }}
                    </h5>

                    <p class="small product-desc mb-0">
                      {{ item.description }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <template v-if="products.length > 4">
          <button
            class="carousel-control-prev"
            type="button"
            data-bs-target="#productsCarousel"
            data-bs-slide="prev"
            aria-label="Previous products"
          >
            <span
              class="carousel-control-prev-icon bg-success rounded-circle"
              aria-hidden="true"
            ></span>
          </button>

          <button
            class="carousel-control-next"
            type="button"
            data-bs-target="#productsCarousel"
            data-bs-slide="next"
            aria-label="Next products"
          >
            <span
              class="carousel-control-next-icon bg-success rounded-circle"
              aria-hidden="true"
            ></span>
          </button>

          <div class="carousel-indicators position-relative mt-4 mb-0">
            <button
              v-for="(group, index) in Math.ceil(products.length / 4)"
              :key="index"
              type="button"
              data-bs-target="#productsCarousel"
              :data-bs-slide-to="index"
              :class="{ active: index === 0 }"
              :aria-current="index === 0 ? 'true' : null"
              :aria-label="`Products slide ${index + 1}`"
            ></button>
          </div>
        </template>
      </div>
    </div>
  </section>

  <!-- ============================= -->
  <!-- SERVICES -->
  <!-- ============================= -->
  <section id="products" class="products-section">
    <div class="container">
      <div class="section-heading text-center mb-5">
        <h2 class="textprimary fw-bold mb-2">Featured Services</h2>
      </div>

      <div
        id="productsCarousel"
        class="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="5000"
      >
        <div class="carousel-inner">
          <div
            v-for="(group, index) in Math.ceil(services.length / 4)"
            :key="index"
            class="carousel-item"
            :class="{ active: index === 0 }"
          >
            <div class="row g-4">
              <div
                v-for="item in services.slice(index * 4, index * 4 + 4)"
                :key="item.id"
                class="col-6 col-md-6 col-lg-3"
              >
                <div class="card product-card h-100 border-0"
                @click="$router.push({ name: 'ServicesPage', query: { category: item.name } })">
                  <div class="product-image-wrapper">
                    <img
                      :src="item.image"
                      :alt="item.name"
                      class="product-img"
                    />

                    <div class="product-overlay">
                      <span class="product-badge">Quality Service</span>
                    </div>
                  </div>

                  <div class="card-body text-center d-flex flex-column">
                    <h5 class="fw-bold mb-2">
                      {{ item.name }}
                    </h5>

                    <p class="small product-desc mb-0">
                      {{ item.description }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <template v-if="services.length > 4">
          <button
            class="carousel-control-prev"
            type="button"
            data-bs-target="#productsCarousel"
            data-bs-slide="prev"
            aria-label="Previous products"
          >
            <span
              class="carousel-control-prev-icon bg-success rounded-circle"
              aria-hidden="true"
            ></span>
          </button>

          <button
            class="carousel-control-next"
            type="button"
            data-bs-target="#productsCarousel"
            data-bs-slide="next"
            aria-label="Next products"
          >
            <span
              class="carousel-control-next-icon bg-success rounded-circle"
              aria-hidden="true"
            ></span>
          </button>

          <div class="carousel-indicators position-relative mt-4 mb-0">
            <button
              v-for="(group, index) in Math.ceil(products.length / 4)"
              :key="index"
              type="button"
              data-bs-target="#productsCarousel"
              :data-bs-slide-to="index"
              :class="{ active: index === 0 }"
              :aria-current="index === 0 ? 'true' : null"
              :aria-label="`Products slide ${index + 1}`"
            ></button>
          </div>
        </template>
      </div>
    </div>
  </section>

  <!-- ============================= -->
  <!-- PARTNERS -->
  <!-- ============================= -->
  <section id="partners" class="partners-section py-5">
    <div class="container">
      <div class="section-heading text-center mb-5">
        <span class="section-label"> Our Network </span>

        <h2 class="textprimary fw-bold mb-2">Our Partners</h2>

        <p class="text-muted mb-0">
          Trusted partners working with us to create better opportunities.
        </p>
      </div>

      <div class="row g-4 align-items-stretch">
        <!-- ============================= -->
        <!-- PARTNERS MARQUEE -->
        <!-- ============================= -->

        <div class="col-lg-8">
          <div class="partners-wrapper h-100">
            <div class="partners-marquee">
              <div class="partners-track">
                <!-- ORIGINAL -->
                <div
                  class="partner-card"
                  v-for="farmer in farmers"
                  :key="farmer.id"
                >
                  <div class="partner-image">
                    <img
                      :src="farmer.image"
                      :alt="farmer.product"
                      loading="lazy"
                    />
                  </div>

                  <div class="partner-content">
                    <span class="partner-label"> Partner </span>

                    <h5 class="fw-bold mb-1">
                      {{ farmer.product }}
                    </h5>

                    <p class="small text-muted mb-3">
                      <i class="bi bi-geo-fill"></i> {{ farmer.location }}
                    </p>

                    <button
                      type="button"
                      class="btn textprimary w-100 rounded-pill"
                    >
                      Visit Partner
                      <i class="bi bi-arrow-right ms-1"></i>
                    </button>
                  </div>
                </div>

                <!-- DUPLICATE FOR SEAMLESS LOOP -->
                <div
                  class="partner-card"
                  v-for="farmer in farmers"
                  :key="'duplicate-' + farmer.id"
                  aria-hidden="true"
                >
                  <div class="partner-image">
                    <img
                      :src="farmer.image"
                      :alt="farmer.product"
                      loading="lazy"
                    />
                  </div>

                  <div class="partner-content">
                    <span class="partner-label"> Partner </span>

                    <h5 class="fw-bold mb-1">
                      {{ farmer.product }}
                    </h5>

                    <p class="small text-muted mb-3">
                      <i class="bi bi-geo-fill"></i> {{ farmer.location }}
                    </p>

                    <a
                      :href="farmer.link || '#'"
                      :target="farmer.link ? '_blank' : null"
                      :rel="farmer.link ? 'noopener noreferrer' : null"
                      class="btn textprimary w-100 rounded-pill"
                      @click="!farmer.link && $event.preventDefault()"
                    >
                      Visit Partner
                      <i class="bi bi-arrow-right ms-1"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ============================= -->
        <!-- APP DOWNLOAD -->
        <!-- ============================= -->

        <div class="col-lg-4">
          <div class="download-card h-100">
            <div class="download-icon">
              <i class="bi bi-phone"></i>
            </div>

            <span class="download-label"> MOBILE APP </span>

            <h3 class="fw-bold textprimary">Take Us With You</h3>

            <p class="text-muted">
              Access our marketplace, connect with partners, explore products
              and manage your activities directly from your mobile device.
            </p>

            <!-- DOWNLOAD BUTTONS -->

            <div class="app-buttons">
              <!-- ANDROID -->

              <a href="https://services.libaaxc.com/images/farm/app-debug.apk" class="app-download-btn" download>
                <div class="app-icon">
                  <i class="bi bi-android2"></i>
                </div>

                <div class="app-text">
                  <small> Download for </small>

                  <strong> Android </strong>
                </div>

                <i class="bi bi-arrow-down-circle ms-auto"></i>
              </a>

              <!-- IOS -->

              <!-- <a
                href=""
                target="_blank"
                rel="noopener noreferrer"
                class="app-download-btn"
              >
                <div class="app-icon">
                  <i class="bi bi-apple"></i>
                </div>

                <div class="app-text">
                  <small> Download on the </small>

                  <strong> App Store </strong>
                </div>

                <i class="bi bi-box-arrow-up-right ms-auto"></i>
              </a> -->
            </div>

            <div class="download-footer">
              <i class="bi bi-shield-check"></i>

              <span> Safe and secure downloads </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Config from "../components/Helpers/Config";

const API_BASE_URL = Config.API_BASE_URL;

export default {
  data() {
    return {
      products: [],
      farmers: [],
      services: []
    };
  },

  mounted() {
    this.fetchProducts();
    this.fetchPartners();
    this.fetchServices();
  },

  methods: {
    async fetchProducts() {
      const url = `${API_BASE_URL}/categories/products`;

      try {
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(
            `API request failed: ${response.status} ${response.statusText}`,
          );
        }

        const result = await response.json();

        const data = Array.isArray(result)
          ? result
          : Array.isArray(result.data)
          ? result.data
          : Array.isArray(result.products)
          ? result.products
          : [];

        console.log("Products received:", data);

        this.products = data.map((item) => ({
          id: item.id,
          name: item.category_code ?? "",
          description: item.category_name ?? "",
          image: item.feature_image ?? "",
        }));
      } catch (error) {
        console.error("Failed to fetch products:", error);
      }
    },

    async fetchServices() {
      const url = `${API_BASE_URL}/categories/services`;

      try {
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(
            `API request failed: ${response.status} ${response.statusText}`,
          );
        }

        const result = await response.json();

        const data = Array.isArray(result)
          ? result
          : Array.isArray(result.data)
          ? result.data
          : Array.isArray(result.products)
          ? result.products
          : [];

        console.log("Products received:", data);

        this.services = data.map((item) => ({
          id: item.id,
          name: item.category_code ?? "",
          description: item.category_name ?? "",
          image: item.feature_image ?? "",
        }));
      } catch (error) {
        console.error("Failed to fetch products:", error);
      }
    },

    async fetchPartners() {
      const url = `${API_BASE_URL}/market_partners`;

      try {
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(
            `API request failed: ${response.status} ${response.statusText}`,
          );
        }

        const result = await response.json();

        const data = Array.isArray(result)
          ? result
          : Array.isArray(result.data)
          ? result.data
          : [];

        this.farmers = data.map((item) => ({
          id: item.id,
          name: item.partner_name ?? "",
          product: item.partner_name ?? "",
          location: item.partner_location ?? "",
          image: item.partner_logo ?? "",
          link: item.partner_link ?? "",
        }));
      } catch (error) {
        console.error("Failed to fetch products:", error);
      }
    },
  },
};
</script>

<style>
/* ================================= */
/* GENERAL */
/* ================================= */

.products-section {
  background: #f6fbf8;
}

.partners-section {
  background: #ffffff;
}

.section-heading {
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
}

.section-label {
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--primary-color);
  margin-bottom: 6px;
}

/* ================================= */
/* PRODUCTS */
/* ================================= */

.product-card {
  overflow: hidden;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.05);
  transition: all 0.35s ease;
}

.product-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.1);
}

.product-image-wrapper {
  height: 220px;
  overflow: hidden;
  position: relative;
  background: #f1f5f3;
}

.product-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.5s ease;
}

.product-card:hover .product-img {
  transform: scale(1.08);
}

.product-overlay {
  position: absolute;
  left: 12px;
  top: 12px;
}

.product-badge {
  background: var(--primary-color);
  color: white;
  padding: 6px 11px;
  border-radius: 50px;
  font-size: 11px;
  font-weight: 600;
}

.product-card .card-body {
  padding: 20px;
}

.product-card h5 {
  color: #1f2937;
}

.product-desc {
  color: #6b7280;
  line-height: 1.6;
}

/* ================================= */
/* PARTNERS */
/* ================================= */

.partners-wrapper {
  background: #f8fffb;
  border-radius: 24px;
  padding: 20px 0;
  overflow: hidden;
  border: 1px solid rgba(25, 135, 84, 0.08);
}

.partners-marquee {
  width: 100%;
  overflow: hidden;
  position: relative;
  padding: 10px 0;
}

/* Fade edges */

.partners-marquee::before,
.partners-marquee::after {
  content: "";
  position: absolute;
  top: 0;
  width: 70px;
  height: 100%;
  z-index: 2;
  pointer-events: none;
}

.partners-marquee::before {
  left: 0;
  background: linear-gradient(to right, #f8fffb, transparent);
}

.partners-marquee::after {
  right: 0;
  background: linear-gradient(to left, #f8fffb, transparent);
}

/* TRACK */

.partners-track {
  display: flex;
  width: max-content;
  gap: 20px;
  animation: partnersScroll 25s linear infinite;
}

.partners-marquee:hover .partners-track {
  animation-play-state: paused;
}

/* PARTNER CARD */

.partner-card {
  width: 250px;
  flex-shrink: 0;
  overflow: hidden;
  background: #ffffff;
  border-radius: 18px;
  border: 1px solid rgba(25, 135, 84, 0.08);
  box-shadow: 0 7px 25px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
}

.partner-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
}

.partner-image {
  height: 140px;
  overflow: hidden;
}

.partner-image img {
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.4s ease;
}

.partner-card:hover .partner-image img {
  transform: scale(1.06);
}

.partner-content {
  padding: 17px;
}

.partner-label {
  display: inline-block;
  color: var(--primary-color);
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 5px;
}

.partner-content h5 {
  color: #1f2937;
  font-size: 17px;
}

.partner-content p {
  min-height: 38px;
  line-height: 1.5;
}

/* MARQUEE */

@keyframes partnersScroll {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
}

/* ================================= */
/* DOWNLOAD CARD */
/* ================================= */

.download-card {
  position: relative;
  overflow: hidden;
  background: linear-gradient(145deg, #f8fffb, #effaf4);

  border-radius: 24px;
  padding: 35px 28px;

  border: 1px solid rgba(25, 135, 84, 0.12);

  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.06);

  display: flex;
  flex-direction: column;
  justify-content: center;
}

/* Decorative circle */

.download-card::after {
  content: "";
  position: absolute;

  width: 180px;
  height: 180px;

  right: -80px;
  top: -80px;

  border-radius: 50%;

  background: rgba(25, 135, 84, 0.07);
}

/* ICON */

.download-icon {
  width: 65px;
  height: 65px;

  margin: 0 auto 15px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;

  background: var(--primary-color);
  color: white;

  font-size: 30px;

  box-shadow: 0 8px 20px rgba(25, 135, 84, 0.25);
}

.download-label {
  text-align: center;
  color: var(--primary-color);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.5px;
  margin-bottom: 5px;
}

.download-card h3 {
  text-align: center;
  margin-bottom: 12px;
}

.download-card > p {
  text-align: center;
  line-height: 1.7;
  font-size: 14px;
}

/* ================================= */
/* APP BUTTONS */
/* ================================= */

.app-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 15px;
}

.app-download-btn {
  width: 100%;
  padding: 11px 14px;

  display: flex;
  align-items: center;

  gap: 12px;

  border-radius: 13px;

  background: var(--primary-color);
  color: white;

  text-decoration: none;

  transition: all 0.3s ease;
}

.app-download-btn:hover {
  background: #146c43;
  color: white;
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(25, 135, 84, 0.2);
}

.app-icon {
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 9px;

  background: rgba(255, 255, 255, 0.15);

  font-size: 23px;
}

.app-text {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
}

.app-text small {
  font-size: 10px;
  opacity: 0.85;
}

.app-text strong {
  font-size: 16px;
}

/* ================================= */
/* DOWNLOAD FOOTER */
/* ================================= */

.download-footer {
  display: flex;
  align-items: center;
  justify-content: center;

  gap: 7px;

  margin-top: 18px;

  color: #6b7280;

  font-size: 11px;
}

.download-footer i {
  color: var(--primary-color);
  font-size: 16px;
}

/* ================================= */
/* RESPONSIVE */
/* ================================= */

@media (max-width: 991px) {
  .product-image-wrapper {
    height: 230px;
  }

  .partners-wrapper {
    margin-bottom: 10px;
  }

  .download-card {
    padding: 35px 25px;
  }
}

@media (max-width: 576px) {
  .products-section,
  .partners-section {
    padding-left: 8px;
    padding-right: 8px;
  }

  .product-image-wrapper {
    height: 170px;
  }

  .product-card .card-body {
    padding: 15px 10px;
  }

  .product-card h5 {
    font-size: 15px;
  }

  .product-desc {
    font-size: 11px;
  }

  .partner-card {
    width: 210px;
  }

  .partner-image {
    height: 135px;
  }

  .download-card {
    padding: 30px 20px;
  }
}

/* ACCESSIBILITY */

@media (prefers-reduced-motion: reduce) {
  .partners-track {
    animation: none;
  }

  .product-card,
  .partner-card,
  .product-img,
  .partner-image img,
  .app-download-btn {
    transition: none;
  }
}
</style>
